const banks: Record< string, string > = {
	alior_bank: 'Alior Bank',
	bank_millennium: 'Bank Millenium',
	bank_nowy_bfg_sa: 'Bank Nowy BFG S.A.',
	bank_pekao_sa: 'Bank PEKAO S.A',
	banki_spbdzielcze: 'Banki SpBdzielcze',
	blik: 'Blik via redirect',
	bnp_paribas: 'BNP Paribas',
	boz: 'BOZ',
	citi_handlowy: 'CitiHandlowy',
	credit_agricole: 'Credit Agricole',
	envelobank: 'EnveloBank',
	etransfer_pocztowy24: 'e-Transfer Poctowy24',
	getin_bank: 'Getin Bank',
	ideabank: 'IdeaBank',
	ing: 'ING',
	inteligo: 'inteligo',
	mbank_mtransfer: 'mBank-mtransfer',
	nest_przelew: 'Nest Przelew',
	noble_pay: 'Noble Pay',
	pbac_z_ipko: 'PBac z iPKO (PKO+BP)',
	plus_bank: 'Plus Bank',
	santander_przelew24: 'Santander-przelew24',
	tmobile_usbugi_bankowe: 'T-Mobile Usbugi Bankowe',
	toyota_bank: 'Toyota Bank',
	volkswagen_bank: 'Volkswagen Bank',
};

export default banks;
